// sync-start:appengine-suffix 969293651 https://github.com/Khan/webapp/blob/master/deploy/services_util.py
// sync-start:cloudrun-suffix 969293651 https://github.com/Khan/webapp/blob/master/deploy/services_util.py
export const KA_DOMAIN_REGEX =
    /(^|\.)(khanacademy\.(org|dev|test|local)|kastatic\.org|(.*-dot-)?khan-academy\.appspot\.com|.*-6fmjyrz2lq-uc.a.run.app)$/;
// sync-end:cloudrun-suffix
// sync-end:appengine-suffix

export const ABSOLUTE_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
